import * as React from 'react';
import Media from 'react-media';

import Imgix from 'js/components/Imgix';

import { Grid, Link, Typography, breakpoints, withTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import type { MarketingContentFieldsFragment } from 'bundles/xddp/__generated__/contentfulTypes';
import Container from 'bundles/xddp/components/shared/Container';
import type { UserAgentProps } from 'bundles/xddp/types';

import 'css!bundles/xddp/components/__styles__/shared/InformationCard';

type Props = UserAgentProps & {
  marketingContent: MarketingContentFieldsFragment;
  theme: Theme;
};

class InformationCard extends React.Component<Props> {
  renderTextBox = () => {
    const { marketingContent } = this.props;

    return (
      <div>
        <Typography className="section-header" variant="h2">
          {marketingContent.title}
        </Typography>
        <Markdown className="description" source={marketingContent.description ?? undefined} />
        {marketingContent.callToActionLink && (
          <Link className="page-link" href={marketingContent.callToActionLink} typographyVariant="bodyPrimary">
            {marketingContent.callToActionLabel}
          </Link>
        )}
      </div>
    );
  };

  renderMediaBox = () => {
    const { marketingContent } = this.props;
    const { visual, visualAlternativeText } = marketingContent;
    if (!visual || !visual?.url) return null;

    return (
      <div>
        <Imgix className="info-card-banner" src={visual.url} alt={visualAlternativeText ?? ''} aria-hidden={true} />
      </div>
    );
  };

  render() {
    const { marketingContent, userAgent } = this.props;

    if (!marketingContent) {
      return null;
    }

    const { textOnLeft } = marketingContent;

    return (
      <Media query={{ minWidth: breakpoints.values.md }} defaultMatches={userAgent?.isMobileBrowser}>
        {(matches) =>
          matches ? (
            <div className="rc-InformationCard">
              <Container>
                <Grid container alignItems="center" spacing={24}>
                  <Grid item md={6}>
                    {textOnLeft ? this.renderTextBox() : this.renderMediaBox()}
                  </Grid>
                  <Grid item md={6}>
                    {textOnLeft ? this.renderMediaBox() : this.renderTextBox()}
                  </Grid>
                </Grid>
              </Container>
            </div>
          ) : (
            <div className="rc-InformationCard">
              <Container>
                <Grid container spacing={24}>
                  <Grid item xs={12}>
                    {this.renderMediaBox()}
                  </Grid>
                  <Grid item xs={12}>
                    {this.renderTextBox()}
                  </Grid>
                </Grid>
              </Container>
            </div>
          )
        }
      </Media>
    );
  }
}

export default withTheme(InformationCard);
